import React from "react";

export default function TrustedBy() {
  return (
    <section id="clients" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center reveal">
          <p className="eyebrow">The Company We Keep</p>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl font-semibold">
            Brands that <span className="text-gradient-gold italic">trust</span> the work
          </h2>
          <p className="mt-5 text-[var(--muted)] max-w-2xl mx-auto">
            From global giants to ambitious MSMEs. A track record built across auto,
            engineering, food, power and beyond.
          </p>
        </div>

        <div className="mt-14 reveal">
          <div className="max-w-3xl mx-auto rounded-3xl border border-[var(--line)] bg-white p-6 sm:p-8 shadow-[0_1px_2px_rgba(16,16,20,0.04),0_10px_30px_-18px_rgba(16,16,20,0.14)]">
            <img
              src="/assets/brands.jpg"
              alt="Brands that trust Nitin Gupta"
              className="w-full h-auto rounded-xl grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-500"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
